import React from 'react';

export const formatProjectListData = (projects) =>
  projects.map((project) => {
    const link = `/projects/${project.slug}` ?? '';
    const image =
      project.card_image?.filename_disk ?? project.feature_image?.filename_disk;
    const subtitle = project.introduction ?? '';

    return {
      link: link,
      image: image,
      subtitle: subtitle,
      ...project,
    };
  });

export const formatPubsListData = (publications) =>
  publications.map((pub) => {
    const link = pub.slug ?? '#';
    const image = pub.image_cover?.filename_disk ?? '';
    const subtitle = pub.description ?? '';
    const title = pub.publication_name ?? '';

    return {
      link: link,
      image: image,
      subtitle: subtitle,
      title: title,
      ...publications,
    };
  });

export const formatPostsListData = (posts) =>
  posts.map((post) => {
    const link = post.slug ?? '#';
    const image = post?.card_image?.filename_disk ?? '';
    const subtitle = post.description ?? '';
    const title = post.title ?? '';

    return {
      link: link,
      image: image,
      subtitle: subtitle,
      title: title,
      ...post,
    };
  });
